export default "__VITE_ASSET__BBlzrP_m__"